export default "__VITE_ASSET__D_0lsTJM__"